import React, { useCallback } from "react";
import {
  Box,
  Grid,
  GridItem,
  SimpleGrid,
  Text,
  Divider,
  useMediaQuery,
} from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import CriancaService from "../../../../../main/services/CriancaService";

import { CustomButton } from "../../../../components/CustomButton";
import { useHistory } from "react-router";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import { servicoAcolhimentoFunc } from "../../../../../helpers/Funcionalidades";
import SemRegistros from "../../../../components/SemRegistros";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { CardAnexo } from "../../../../components/CardAnexo";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { useAuthProvider } from "../../../../../Context/AuthProvider";

export const VisualizarPageAnexos = ({
  id,
  props,
  idade16,
  idTipoPendencia,
  setLoadingPainel,
}) => {
  const { values } = useFormikContext();
  const [data, setData] = useState([]);
  const [dataDefault, setDataDefault] = useState([]);
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const [loadingAnexosDefault, setLoadingAnexosDefault] = useState(false);
  const [tipoAnexos, setTipoAnexos] = useState({
    options: [],
    isLoading: false,
  });
  const [tipoCategorias, setTipoCategorias] = useState({
    options: [],
    isLoading: false,
  });

  const [ordens, setOrdens] = useState({
    options: [
      { id: 1, descricao: "Mais Recente (data da inclusão)" },
      { id: 2, descricao: "Mais Antigo (data da inclusão)" },
    ],
    isLoading: false,
  });
  const [loadingAnexos, setLoadingAnexos] = useState(false);
  const [isLessThan600] = useMediaQuery("(max-width: 600px)");
  const [isLessThan1609] = useMediaQuery("(max-width: 1609px)");

  const handleGetTipoCategorias = () => {
    setTipoCategorias({
      ...tipoCategorias,
      isLoading: true,
    });

    CriancaService.getListaAnexoCategorias().then((res) => {
      const tempOptions = res.data.map((item) => {
        return {
          id: item.id,
          descricao: item.nome,
        };
      });
      setTipoCategorias({
        options: tempOptions,
        isLoading: false,
      });
    });
  };

  const handleGetTipoAnexo = () => {
    setTipoAnexos({
      ...tipoAnexos,
      isLoading: true,
    });

    CriancaService.getListaTipoAnexos()
      .then((res) => {
        const categoriaId = values.categoriaSearch.id;

        let filteredData = res.data;

        if (categoriaId) {
          filteredData = filteredData.filter((item) => {
            return item.grupo.id === categoriaId;
          });
        }

        let tempOptions = filteredData.map((item) => {
          return {
            id: item.id,
            descricao: item.nmCategoria,
          };
        });
        if (!idade16) {
          tempOptions = tempOptions.filter(
            (item) => item.id !== 5 && item.id !== 12
          );
        }

        tempOptions.sort((a, b) => a.descricao.localeCompare(b.descricao));
        setTipoAnexos({
          options: tempOptions,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log("Erro ao buscar tipos de anexo:", err);
        setTipoAnexos({
          options: [],
          isLoading: false,
        });
      });
  };

  const handleGetOrdem = () => {
    setOrdens({
      ...ordens,
      isLoading: true,
    });
  };

  const fetchDataDefault = useCallback(() => {
    setLoadingAnexosDefault(true);
    CriancaService.getListaAnexo(id)
      .then((res) => {
        setDataDefault(res.data);
        setLoadingAnexosDefault(false);
      })
      .catch((err) => {
        console.log("Erro no get de anexos");
        setLoadingAnexosDefault(false);
      });
  }, [id]);

  const fetchData = useCallback(() => {
    setLoadingAnexos(true);
    CriancaService.getListaAnexo(id)
      .then((res) => {
        const rawData = res.data;
        const filteredData = rawData.filter((anexo) => {
          const dataUpload = new Date(anexo.dataUpload);

          const dataSearch1 = values?.dataSearch1
            ? parseDate(values.dataSearch1)
            : null;

          const dataSearch2 = values?.dataSearch2
            ? parseDate(values.dataSearch2)
            : null;

          if (dataSearch2) {
            dataSearch2.setHours(23, 59, 59, 999);
          }

          const isDateMatch =
            (!dataSearch1 || dataUpload >= dataSearch1) &&
            (!dataSearch2 || dataUpload <= dataSearch2);

          const isCategoriaMatch =
            !values?.categoriaSearch?.id ||
            anexo.idCategoria === values?.categoriaSearch?.id;

          const isTipoAnexoMatch =
            !values?.tipoSearch?.id || anexo.idTipo === values?.tipoSearch?.id;

          return isDateMatch && isCategoriaMatch && isTipoAnexoMatch;
        });

        let finalData = filteredData;
        let finalDataDefault = res.data;

        if (!idade16) {
          finalData = finalData.filter(
            (anexo) => anexo.idTipo !== 5 && anexo.idTipo !== 12
          );
          finalDataDefault = finalDataDefault.filter(
            (anexo) => anexo.idTipo !== 5 && anexo.idTipo !== 12
          );
        }

        finalData.sort((a, b) => {
          const dateA = new Date(a.dataUpload);
          const dateB = new Date(b.dataUpload);

          if (values?.ordemSearch?.id === 1) {
            return dateB - dateA;
          } else if (values?.ordemSearch?.id === 2) {
            return dateA - dateB;
          } else {
            return dateB - dateA;
          }
        });

        setData(finalData);
        setDataDefault(finalDataDefault);
        setLoadingAnexos(false);
      })
      .catch((err) => {
        console.log("Erro no get de anexos");
        setLoadingAnexos(false);
      });
  }, [
    id,
    values.dataSearch1,
    values.dataSearch2,
    values.ordemSearch,
    values.categoriaSearch?.id,
    values.tipoSearch?.id,
    idade16,
  ]);

  function parseDate(dateString) {
    const [day, month, year] = dateString.split("/");
    const parsedDate = new Date(`${year}-${month}-${day}`);

    const utcDate = new Date(
      parsedDate.getTime() + parsedDate.getTimezoneOffset() * 60000
    );
    return utcDate;
  }
  useEffect(() => {
    fetchDataDefault();
  }, [fetchDataDefault]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <>
      <Group
        border={
          ["49", "51"].includes(idTipoPendencia)
            ? "3px solid #4299E199"
            : "#CACACA"
        }
        title="Anexos"
      >
        {!loadingAnexosDefault ? (
          <>
            <SimpleGrid
              mt="30px"
              columns={{ base: 1, sm: 2, lg: 5 }}
              spacing="20px"
              marginTop={"-50px"}
              dir="rtl"
            >
              {!roleKeycloack.includes(
                servicoAcolhimentoFunc.visualizarParteConsulente
              ) && (
                <CustomButton
                  label="Anexar"
                  onClick={() => {
                    history.push(`/crianca/cadastrar-anexos/${id}`);
                  }}
                />
              )}
            </SimpleGrid>
            {dataDefault.length > 0 ? (
              <>
                <Grid
                  templateColumns="repeat(4, 1fr) 1fr"
                  mt={
                    !roleKeycloack.includes(
                      servicoAcolhimentoFunc.visualizarParteConsulente
                    )
                      ? 4
                      : 16
                  }
                  gap={4}
                  mb={4}
                >
                  <GridItem colSpan={{ base: 5, lg: 2 }}>
                    <CustomSelectWField
                      fieldName="categoriaSearch"
                      placeholder="Selecione a Categoria"
                      getOptionLabel={(option) => option.descricao}
                      getOptionValue={(option) => option.id}
                      isLoading={tipoCategorias.isLoading}
                      options={tipoCategorias.options}
                      onChange={(value) => {
                        props.setFieldValue(
                          "categoriaSearch",
                          value ? value : ""
                        );
                        props.setFieldValue("tipoSearch", "");
                      }}
                      onFocus={handleGetTipoCategorias}
                    />
                  </GridItem>
                  <GridItem colSpan={{ base: 5, lg: 2 }}>
                    <CustomSelectWField
                      fieldName="tipoSearch"
                      placeholder="Selecione o Tipo de Anexo"
                      getOptionLabel={(option) => option.descricao}
                      getOptionValue={(option) => option.id}
                      isLoading={tipoAnexos.isLoading}
                      options={tipoAnexos.options}
                      onChange={(value) => {
                        props.setFieldValue("tipoSearch", value ? value : "");
                      }}
                      onFocus={handleGetTipoAnexo}
                    />
                  </GridItem>
                  <GridItem colSpan={{ base: 5, lg: 2 }}>
                    <CustomSelectWField
                      fieldName="ordemSearch"
                      placeholder="Ordernar por..."
                      getOptionLabel={(option) => option.descricao}
                      getOptionValue={(option) => option.id}
                      isLoading={ordens.isLoading}
                      options={ordens.options}
                      onChange={(value) => {
                        props.setFieldValue("ordemSearch", value ? value : "");
                      }}
                      onFocus={
                        ordens.options.length === 0 ? handleGetOrdem : null
                      }
                    />
                  </GridItem>
                  <GridItem
                    colSpan={{ base: 5, lg: 3 }}
                    display={"flex"}
                    gap={6}
                    alignItems={"center"}
                  >
                    <Box w={{ m: "0" }}>
                      <CustomDatepickerWField
                        fieldName="dataSearch1"
                        placeholder="DD/MM/AAAA"
                      />
                    </Box>

                    <Text>Até</Text>

                    <Box w={{ m: 0 }}>
                      <CustomDatepickerWField
                        fieldName="dataSearch2"
                        placeholder="DD/MM/AAAA"
                      />
                    </Box>
                  </GridItem>
                </Grid>

                <Divider
                  mt={"10px"}
                  orientation="horizontal"
                  borderColor={"#DDEBEA"}
                />
                {!loadingAnexos ? (
                  <Box
                    maxH="500px"
                    overflowY={
                      data && data.length > (isLessThan1609 ? 6 : 8)
                        ? "auto"
                        : "initial"
                    }
                  >
                    {data && data.length > 0 ? (
                      <Grid
                        templateColumns={
                          !isLessThan600 && data.length > 3
                            ? "repeat(auto-fit, minmax(230px, 1fr))"
                            : !isLessThan600 && data.length <= 3
                            ? "repeat(auto-fill, minmax(230px, 1fr))"
                            : ""
                        }
                        mt={6}
                        gap={6}
                        justifyContent="center"
                        alignItems="center"
                      >
                        {data.map((anexo) => {
                          const customDateDocument = anexo.dataDocumento
                            ? new Date(anexo.dataDocumento).toLocaleDateString(
                                "pt-BR"
                              )
                            : "";

                          const customDateInitial = anexo.dataUpload
                            ? new Date(anexo.dataUpload).toLocaleDateString(
                                "pt-BR"
                              )
                            : "";

                          const data = {
                            tipoAnexo: {
                              id: anexo.idTipo,
                              descricao: anexo.tipo,
                              grupo: {
                                id: anexo.idCategoria,
                                nome: anexo.categoria,
                              },
                              idFiliacao: anexo.idFiliacao
                                ? anexo.idFiliacao
                                : null,
                            },
                          };

                          let editarIdade;

                          if (
                            (anexo.idTipo === 5 || anexo.idTipo === 12) &&
                            !idade16
                          ) {
                            editarIdade = false;
                          } else {
                            editarIdade = true;
                          }
                          return (
                            <CardAnexo
                              title={`${anexo.tipo ? anexo.tipo : ""}`}
                              responsavel={`${
                                anexo.responsavel ? anexo.responsavel : ""
                              }`}
                              dataDocumento={`${customDateDocument}`}
                              observacoes={`${
                                anexo.observacao ? anexo.observacao : ""
                              }`}
                              dataInitial={`${customDateInitial}`}
                              idDelete={anexo.id}
                              idCrianca={id}
                              key={anexo.id}
                              tipoAnexo={data}
                              fetchData={fetchData}
                              idade16={editarIdade}
                              roleKeycloack={roleKeycloack}
                              user={user}
                              idOrgaoExterno={anexo.idOrgaoExterno}
                              idOrgao={anexo.idOrgao}
                              fotoPrincipal={anexo?.fotoPrincipal}
                              setLoadingPainel={setLoadingPainel}
                            />
                          );
                        })}
                      </Grid>
                    ) : (
                      <Box mt={4}>
                        <SemRegistros buttonVisible={true} half />
                      </Box>
                    )}
                  </Box>
                ) : (
                  <LoadingSpinner />
                )}
              </>
            ) : (
              <Box mt={4}>
                <SemRegistros buttonVisible={true} half />
              </Box>
            )}
          </>
        ) : (
          <LoadingSpinner />
        )}
      </Group>
    </>
  );
};
